var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_7581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0079 8.104C10.2992 8.104 1.92188 14.7735 1.92188 23.0054C1.92188 31.2372 10.2938 37.9013 23.0079 37.9013C35.722 37.9013 44.0886 31.2264 44.0886 23.0054C44.0886 14.7843 35.7112 8.104 23.0079 8.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7798 28.5704C30.4001 27.9401 42.6239 25.4242 41.1155 18.453C40.5768 15.9479 38.0016 13.195 34.112 11.2825C30.5931 9.77064 26.795 9.01798 22.9656 9.07368C11.1727 9.07368 2.96777 15.3122 2.96777 23.0053C2.96777 28.3603 6.94901 33.0096 13.3546 35.3369C14.696 31.7597 20.1049 29.7233 26.7798 28.5704Z",
    fill: "#007DC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0084 31.0381C17.7127 31.7007 15.2884 33.4085 13.7314 35.4826C16.6962 36.4678 19.8036 36.9557 22.9276 36.9264C34.7259 36.9264 42.9308 30.6933 42.9308 23.0056C42.9307 22.3313 42.8676 21.6586 42.7423 20.9961C42.3705 30.0253 28.816 30.3162 23.0084 31.0381Z",
    fill: "url(#paint0_linear_1121_7581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5656 15.7324H7.61133L7.65442 15.8456C7.81158 16.4627 7.86439 17.1019 7.81066 17.7365C7.81066 17.8981 7.81066 26.895 7.81066 26.895H7.88607C7.88607 26.895 9.69084 26.9596 11.3825 26.9596C14.9166 26.9596 17.3085 24.5677 17.3085 21.0012C17.287 17.7904 15.0405 15.7324 11.5656 15.7324ZM9.50227 16.7291C9.72854 16.7291 10.4289 16.659 10.9299 16.659C13.9522 16.659 15.3583 18.1244 15.3583 21.2652C15.3583 24.4976 14.1084 26.1138 11.5387 26.1138C9.65312 26.1138 9.50227 26.0222 9.50227 24.9071V16.7291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9051 26.7929C27.8458 26.1357 27.8189 25.7154 27.8189 25.3114V21.4056H25.9441L26.0033 21.5295C26.1528 21.9096 26.2172 22.3178 26.1919 22.7255C26.1919 22.7524 26.1919 25.4191 26.1273 26.071C25.6495 26.1758 25.1618 26.2282 24.6727 26.2272C21.6881 26.2272 20.1742 24.5141 20.1742 21.1416C20.1742 18.5665 21.8766 16.6432 24.3171 16.4654C25.4957 16.3426 26.6764 16.6783 27.6141 17.4028L27.7488 17.5213V15.9428H27.6842C26.8374 15.7596 25.9752 15.6568 25.109 15.6357C20.7992 15.6357 18.251 17.893 18.251 21.6803C18.251 25.7101 21.381 27.1485 24.3117 27.1485C25.491 27.1523 26.6689 27.0658 27.835 26.8899H27.9105L27.9051 26.7929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.613 20.7534C35.203 20.611 35.7295 20.2777 36.1104 19.8051C36.4914 19.3326 36.7055 18.7474 36.7194 18.1406C36.7194 16.6321 35.3564 15.7324 33.0776 15.7324H29.6943V15.8294C29.7802 16.3165 29.8145 16.8113 29.7967 17.3055V26.965H29.8775C29.8775 26.965 31.2082 26.9381 32.8405 26.9381C35.6851 26.9381 37.3174 25.7044 37.3174 23.5495C37.339 22.2188 36.2346 21.1036 34.613 20.7534ZM31.5045 21.2922H32.3772C34.3921 21.2922 35.4157 22.0841 35.4157 23.6464C35.4157 25.2087 34.5376 26.0923 32.722 26.0923C31.8493 26.0923 31.5045 25.7744 31.5045 24.9609V21.2922ZM31.5045 16.5998H32.6089C34.349 16.5998 35.0924 17.1385 35.0924 18.3614C35.0924 19.7622 34.182 20.4194 32.221 20.4194H31.4991L31.5045 16.5998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1121_7581",
    x1: 13.252,
    y1: 28.9586,
    x2: 43.1732,
    y2: 28.9586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#007DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0083CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72BF44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_7581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.1667,
    height: 29.792,
    fill: "white",
    transform: "translate(1.91699 8.104)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/대구-46.3202cc1e563cf23619a80adec1941751.svg";
export { ForwardRef as ReactComponent };